<template align="center">
    <v-switch
      class="nav-bar-switch"
      v-model="lightTheme"
      :label="$t('NavBar.Header.NavBarSwitch.Switch-Theme')">
    </v-switch>
</template>
<script>
export default {
  data: () => ({
    lightTheme: false
  }),
  created(){
    // this.ligthTheme = !!localStorage.getItem('TAKT_theme');
    // this.$vuetify.theme.dark = !!localStorage.getItem('TAKT_theme');
  },
  watch: {
    lightTheme() {
      localStorage.setItem('TAKT_theme', !this.$vuetify.theme.dark);
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      // localStorage.setItem('TAKT_theme', this.$vuetify.theme.dark);
    }
  }
}
</script>
<style>
  .nav-bar-switch {
    height: 24px;
    overflow: hidden;
  }
</style>
